<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
    <app-project-selection-header [projectAdminContext]="projectAdminContext"></app-project-selection-header>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <sc-flex-fitting-content [vertical]="true">
        <app-project-details [projectId]="projectAdminContext.currentlyActiveProject"></app-project-details>
    </sc-flex-fitting-content>
</sc-flex>